import * as Schema from 'owa-graph-schema';
import { getMailboxRequestOptions } from 'owa-request-options-types';
import ApplyConversationActionJsonResponse from 'owa-service/lib/contract/ApplyConversationActionJsonResponse';
import ApplyConversationActionRequest from 'owa-service/lib/contract/ApplyConversationActionRequest';
import applyConversationActionOperation from 'owa-service/lib/operation/applyConversationActionOperation';
import RequestOptions from 'owa-service/lib/RequestOptions';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';

/**
 * Sends out the service request to apply conversation action
 */
export default function applyConversationActionService(
    requestBody: ApplyConversationActionRequest,
    mailboxInfo: Schema.MailboxInfoInput | null | undefined,
    errorPrefix: string,
    header = getJsonRequestHeader(),
    requestOptions?: RequestOptions
): Promise<ApplyConversationActionJsonResponse> {
    if (
        !requestBody ||
        !requestBody.ConversationActions ||
        requestBody.ConversationActions.length === 0
    ) {
        throw new Error(`${errorPrefix}: ApplyConversationAction requestBody is invalid!`);
    }

    requestOptions = requestOptions || {};
    const headers = requestOptions?.headers?.set
        ? new Headers(<Headers>requestOptions.headers)
        : new Headers();
    headers.set(
        'X-OWA-ActionSource',
        'ApplyConversationAction_' + requestBody.ConversationActions[0].Action
    );

    requestOptions = {
        ...requestOptions,
        headers,
    };

    const options = getMailboxRequestOptions(mailboxInfo, requestOptions);

    return applyConversationActionOperation(
        {
            Header: header,
            Body: requestBody,
        },
        options
    );
}
